import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { listMyNotifications, subscribeToMyNotifications } from '@/api/notifications';
import { useAuthStore } from '@/stores/authStore';
import { hubQueryKeys } from '@/lib/hubQueryClient';

export function useMyNotifications() {
  const user = useAuthStore((s) => s.user);
  const queryClient = useQueryClient();
  const userId = user?.id ?? '';
  const queryKey = hubQueryKeys.notifications(userId);

  const query = useQuery({
    queryKey,
    queryFn: () => listMyNotifications(userId),
    enabled: Boolean(userId),
    staleTime: 30_000,
  });

  useEffect(() => {
    if (!userId) return;
    return subscribeToMyNotifications(userId, (items) => {
      queryClient.setQueryData(queryKey, items);
    });
  }, [userId, queryClient, queryKey]);

  return query;
}
